export const Links = [
    { name: "Home", link: "/" },
    { name: "Portfolio", link: "/portfolio" },
    { name: "Blogs", link: "/blogs" },
];